<template>
  <v-snackbar
    class="noInternet"
    v-model="show"
    bottom
    color="info"
    :timeout="-1"
  >
    <v-row align="center" justify="center">
      <v-col cols="2">
        <v-icon>mdi-wifi-off</v-icon>
      </v-col>
      <v-col cols="10">
        Ingen internett tilgang! Sjekk dine innstillinger
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    show: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
});
</script>

<style lang="scss">
.noInternet {
  .v-snack {
    padding-bottom: calc(56px + env(safe-area-inset-bottom)) !important;
  }
}
</style>
